import script from "./TokensDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokensDetails.vue?vue&type=script&lang=ts&setup=true"

import "./TokensDetails.vue?vue&type=style&index=0&id=2e944cf9&scoped=true&lang=scss"

import exportComponent from "/builds/javier-sedano/oidc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e944cf9"]])

export default __exports__